import {ACTION_CODE} from './_actionCode';
import {ProductionCategoryService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'CREATE_PRODUCTIONCATEGORY';

export async function createProductionCategory(userData: Record<string, any>, productionCategory: Record<string, any>) {
    try {
        LoggerService.logInfo('Action - createProductionCategory - Start');

        const createProductionCategoryResult = await ProductionCategoryService.createProductionCategory(userData, productionCategory);

        LoggerService.logInfo('Action - createProductionCategory - End - Success');

        return ResultModel.newSuccessResult(createProductionCategoryResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - createProductionCategory - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la création d‘une banque.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
